/**
 * Slugs fixos consumidos pelo site Balcão Scania (balcao-scania).
 * Ao editar conteúdos e-commerce no Xpro, o slug não pode ser alterado para estes tipos.
 */
export const ECOM_BALCAO_SCANIA_FIXED_SLUGS = Object.freeze({
  como_comprar: "como-comprar",
  pagamento: "pagamento",
  entregas: "entregas",
  trocas: "trocas",
  faq: "faq",
  privacidade: "declaracao-de-privacidade",
  cookies: "cookies",
  termos: "terms",
  lgpd: "lgpd",
  links_rodape: "institucional",
  sugestoes_busca: "sugestoes-busca",
  segmentos: "segmentos",
  sobre: "sobre",
  home_seo: "home-seo",
  pdp_retire_concessionaria: "retire-concessionaria",
  pdp_aplicacao: "aplicacao",
  pdp_whatsapp_frete: "whatsapp-frete",
});

/** @param {string} tipo */
export function getEcomBalcaoScaniaFixedSlug(tipo) {
  const key = String(tipo || "").trim();
  if (!key) return null;
  return ECOM_BALCAO_SCANIA_FIXED_SLUGS[key] ?? null;
}

/** @param {string} tipo */
export function isEcomBalcaoScaniaFixedSlugType(tipo) {
  return getEcomBalcaoScaniaFixedSlug(tipo) != null;
}
